<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "GENERIC.ENTERPRISES" | translategt }}
    </div>
    <div class="mat-body-2 enterprises-count">
      {{ enterprisesResultsLength }}
      {{ "GENERIC.ENTERPRISES" | translategt }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <div class="flex-row-start-center search-row">
      <label for="searchEnterprise" class="mr-8">
        <mat-icon class="secondary-text">search</mat-icon>
      </label>
      <mat-form-field floatLabel="auto" class="search-field">
        <mat-label>{{
          "GENERIC.FILTERING_PLACEHOLDER" | translate | titlecase
        }}</mat-label>
        <input
          id="searchEnterprise"
          [(ngModel)]="enterprisesFilterValue"
          matInput
          #enterprisesFilter
        />
        <button
          mat-button
          *ngIf="enterprisesFilterValue"
          matSuffix
          mat-icon-button
          (click)="clearEnterpriseSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div
      *ngIf="!isEnterprisesLoadingResults && enterprisesResultsLength === 0"
      class="pb-8 mat-body-2 flex-row-center-start"
    >
      {{ "GENERIC.NO_RESULTS" | translate }}
    </div>

    <div *ngIf="isEnterprisesLoadingResults" class="loading-bar">
      <mat-progress-bar
        mode="query"
        color="warn"
        style="height: 3px"
      ></mat-progress-bar>
    </div>

    <mat-paginator
      #enterprisesPaginator
      [length]="enterprisesResultsLength"
      class="clients-paginator"
      (page)="datatableHelperService.onPaginator($event, 'enterprises')"
      showFirstLastButtons="true"
      [pageIndex]="0"
      [pageSize]="'enterprises' | tableSizePipe: 'large'"
      [pageSizeOptions]="datatableHelperService.pageSizeOptions"
    >
    </mat-paginator>

    <mat-table
      #enterprisesTable
      class="enterprises-table"
      matSort
      matSortStart="desc"
      #enterprisesSort="matSort"
      [@animateStagger]="{ value: '50' }"
      [dataSource]="enterprisesDataSource"
    >
      <ng-container cdkColumnDef="name">
        <mat-header-cell *cdkHeaderCellDef mat-sort-header>
          {{ "GENERIC.NAME" | translate }}
        </mat-header-cell>
        <mat-cell *cdkCellDef="let enterprise">
          <div
            class="flex-row-space-between-center enterprise-row"
            (click)="onSelectEnterprise(enterprise)"
          >
            <p class="text-truncate font-weight-600">
              {{ enterprise.name }}
            </p>
            <mat-radio-button
              [checked]="selectedEnterprise === enterprise"
            ></mat-radio-button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *cdkHeaderRowDef="enterprisesDisplayedColumns"
      ></mat-header-row>
      <mat-row
        *cdkRowDef="let enterprise; columns: enterprisesDisplayedColumns"
        matRipple
        (click)="onSelectEnterprise(enterprise)"
      >
      </mat-row>
    </mat-table>

    <div
      *ngIf="isEnterprisesLoadingResults && !isFirstLoad"
      class="flex-row-center-start"
    >
      <mat-progress-bar
        mode="query"
        color="warn"
        style="height: 3px"
      ></mat-progress-bar>
    </div>

    <div class="mt-8 selected-label text-bold" *ngIf="selectedEnterprise">
      {{ "ATTACH_ENTERPRISE.SELECTED_ENTERPRISE" | translate }}
      {{ selectedEnterprise.name }}
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      [disabled]="!selectedEnterprise"
      (click)="onAttachEnterprise()"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "ATTACH_ENTERPRISE.ATTACH" | translate }}
    </button>
    <button
      mat-raised-button
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4 primary"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
